/**
 * Shared ECharts theme — brand palette + Inter typography.
 * Spread into every option object so panels stay visually consistent.
 *
 *   const option = { ...echartsTheme, xAxis: ..., series: ... };
 */
import {
  ECHARTS_COLORS,
  ECHARTS_AXIS_COLOR,
  ECHARTS_SPLIT_COLOR,
} from "./tokens";

export const echartsTheme = {
  color: [...ECHARTS_COLORS],
  textStyle: { fontFamily: "Inter" },
  axisLine: { lineStyle: { color: ECHARTS_AXIS_COLOR } },
  splitLine: { lineStyle: { color: ECHARTS_SPLIT_COLOR } },
};
